interface Props {
    title?: string;
    description?: string;
    canonical?: string;
    image?: string;
    imageAlt?: string;
}

export const updateMetadata = (props: Props) => {
    if (props.title) {
        document.title = props.title;

        let ogTitle = document.querySelector("meta[property='og:title']");
        if (!ogTitle) {
            ogTitle = document.createElement("meta");
            ogTitle.setAttribute("property", "og:title");
            document.head.appendChild(ogTitle);
        }
        ogTitle.setAttribute("content", props.title);

        let dcTitle = document.querySelector("meta[name='DC.title']");
        if (!dcTitle) {
            dcTitle = document.createElement("meta");
            dcTitle.setAttribute("name", "DC.title");
            document.head.appendChild(dcTitle);
        }
        dcTitle.setAttribute("content", props.title);
    }

    if (props.canonical) {
        let canonicalUrl = new URL(props.canonical)
        if (!canonicalUrl.pathname.startsWith("/products")) {
            canonicalUrl.pathname = canonicalUrl.pathname.substring(3)
        }

        let metaRobots = document.querySelector("meta[name='robots']");
        if(!metaRobots) {
            metaRobots = document.createElement("meta");
            metaRobots.setAttribute("name", "robots");
            document.head.appendChild(metaRobots);
        }

        let metaGooglebot = document.querySelector("meta[name='googlebot']");
        if(!metaGooglebot) {
            metaGooglebot = document.createElement("meta");
            metaGooglebot.setAttribute("name", "googlebot");
            document.head.appendChild(metaGooglebot);
        }

        if(canonicalUrl.searchParams.get("color")?.split(",").length > 1) {
            const first = canonicalUrl.searchParams.get("color").split(",")[0];
            canonicalUrl.searchParams.set("color", first);

            metaRobots.setAttribute("content", "noindex, nofollow")
            metaGooglebot.setAttribute("content", "noindex, nofollow")
        } else {
            metaRobots.setAttribute("content", "index, follow")
            metaGooglebot.setAttribute("content", "index, follow")
        }

        let canonical = document.querySelector("link[rel='canonical']");
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", canonicalUrl.href);

        document.querySelectorAll("link[rel='alternate']").forEach(elem => {
            const url = new URL(canonicalUrl);
            const langArr = elem.getAttribute("hrefLang").split("-");
            let lang: string;

            if (langArr.length > 1) {
                lang = langArr[1].toLowerCase();
            } else {
                lang = langArr[0].toLowerCase();
            }

            if (lang != "de" && lang != "default") {
                url.pathname = `/${lang}${url.pathname}`
            }

            elem.setAttribute("href", url.href)
        })
    }

    if (props.image) {
        let image = document.querySelector("meta[property='og:image']")
        if (!image) {
            image = document.createElement("meta")
            image.setAttribute("property", "og:image")
            document.head.appendChild(image)
        }
        image.setAttribute("content", props.image)

        let imageWidth = document.querySelector("meta[property='og:image:width']")
        if (!imageWidth) {
            imageWidth = document.createElement("meta")
            imageWidth.setAttribute("property", "og:image:width")
            document.head.appendChild(imageWidth)
        }
        imageWidth.setAttribute("content", "200")

        let imageHeight = document.querySelector("meta[property='og:image:height']")
        if (!imageHeight) {
            imageHeight = document.createElement("meta")
            imageHeight.setAttribute("property", "og:image:height")
            document.head.appendChild(imageHeight)
        }
        imageHeight.setAttribute("content", "200")

        if (props.imageAlt) {
            let imageAlt = document.querySelector("meta[property='og:image:alt']")
            if (!imageAlt) {
                imageAlt = document.createElement("meta")
                imageAlt.setAttribute("property", "og:image:alt")
                document.head.appendChild(imageAlt)
            }
            imageAlt.setAttribute("content", props.imageAlt)
        }
    }

    if (props.description) {
        let description = document.querySelector("meta[name='description']");
        if (!description) {
            description = document.createElement("meta");
            description.setAttribute("name", "description");
            document.head.appendChild(description);
        }
        description.setAttribute("content", props.description);

        let ogDescription = document.querySelector("meta[property='og:description']");
        if (!ogDescription) {
            ogDescription = document.createElement("meta");
            ogDescription.setAttribute("property", "og:description");
            document.head.appendChild(ogDescription);
        }
        ogDescription.setAttribute("content", props.description);

        let dcDescription = document.querySelector("meta[name='DC.Description']");
        if (!dcDescription) {
            dcDescription = document.createElement("meta");
            dcDescription.setAttribute("name", "DC.Description");
            document.head.appendChild(dcDescription);
        }
        dcDescription.setAttribute("content", props.description);
    }
}
